<template>
  <section class="sms-recover-pin-screen">
    <form-pin-inputs :loading="btnLoading" :error="error" @send-code="sendCode($event)" @remove-error="removeError"/>
    <span class="pin-subtitle" :class="{'pin-subtite-error': error}">{{pinMessage}}</span>
    <v-row class="mb-3" no-gutters>
      <v-btn v-if="timer > 0" width="100%" class="mt-5 button-height" :color="getAssets.colors.form.buttonBackground" disabled :style="{ color: getAssets.colors.form.buttonFont }">{{buttonText}} <strong class="pl-1">{{secondsText}}</strong></v-btn>
      <v-btn v-else width="100%" class="mt-5 button-height" :color="getAssets.colors.form.buttonBackground" :style="{ color: getAssets.colors.form.buttonFont }" :loading="btnLoading" @click="submitPhoneNumber">Reenviar o código</v-btn>
    </v-row>
  </section>
</template>

<script>
export default {
  components: {
    FormPinInputs: () => import('@/components/dynamic/FormPinInputs.vue')
  },
  props: {
    btnLoading: Boolean,
    error: Boolean,
    pinMessage: String,
    buttonText: String,
    secondsText: String,
    timer: Number
  },
  computed: {
    getAssets() {
      return this.$store.getters.GET_ASSETS
    }
  },
  methods: {
    removeError() {
      this.$emit('remove-error')
    },
    submitPhoneNumber() {
      this.$emit('submit')
    },
    sendCode(code) {
      this.$emit('send-code', code)
    }
  }
}
</script>
